/**
 * RGV a11y — empty SPR review links (Sighted Pareto #3 / link-name)
 *
 * `.reviewLink` wraps a Shopify Product Reviews badge. When SPR has no
 * reviews the badge stays empty (or “0 reviews”), so the anchor is a
 * nameless / useless control. Liquid supplies `aria-label`; this script
 * hides links that never gain real review content.
 */
(function () {
  var SELECTOR = 'a.reviewLink';

  function badgeIsEmpty(link) {
    var badge = link.querySelector(
      '.shopify-product-reviews-badge, .spr-badge, [class*="spr-badge"]'
    );
    if (!badge) return true;
    var text = (badge.textContent || '').replace(/\u00a0/g, ' ').replace(/\s+/g, ' ').trim();
    if (!text) return true;
    if (/^0(\.0+)?\s*reviews?$/i.test(text)) return true;
    if (/^no reviews?/i.test(text)) return true;
    if (/^be the first/i.test(text)) return true;
    return false;
  }

  function scrub() {
    var links = document.querySelectorAll(SELECTOR);
    for (var i = 0; i < links.length; i++) {
      var link = links[i];
      var empty = badgeIsEmpty(link);
      var wrap = link.parentElement;
      if (empty) {
        link.setAttribute('hidden', '');
        link.setAttribute('aria-hidden', 'true');
        link.setAttribute('tabindex', '-1');
        if (wrap && wrap.classList && wrap.classList.contains('review')) {
          wrap.setAttribute('hidden', '');
        }
      } else {
        link.removeAttribute('hidden');
        link.removeAttribute('aria-hidden');
        link.removeAttribute('tabindex');
        if (wrap && wrap.classList && wrap.classList.contains('review')) {
          wrap.removeAttribute('hidden');
        }
      }
    }
  }

  function start() {
    scrub();
    var obs = new MutationObserver(function () {
      scrub();
    });
    obs.observe(document.documentElement, {
      childList: true,
      subtree: true,
      characterData: true
    });
    setTimeout(scrub, 1000);
    setTimeout(scrub, 3000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
